type CreateReviewsPageUrlProps = {
  colorKey: string | null | undefined
  handle: string
  type: 'write-review' | 'read-review'
  query?: Record<string, string | undefined>
}

export const createReviewsPageUrl = (props: CreateReviewsPageUrlProps) => {
  const baseUrl = `/products/${props.handle}/reviews`

  const searchParams = new URLSearchParams()
  if (props.colorKey) {
    searchParams.set('color', props.colorKey)
  }
  if (props.type === 'write-review') {
    searchParams.set('write-review', 'true')
  }
  if (props.query) {
    const query = props.query
    Object.keys(query).forEach(queryKey => {
      const queryValue = query[queryKey]
      if (queryValue) {
        searchParams.set(queryKey, queryValue)
      }
    })
  }
  const searchParamsString = searchParams.toString()

  return `${baseUrl}${searchParamsString.length > 0 ? '?' : ''}${searchParamsString}`
}

export const createCanonicalReviewsPageUrl = (
  props: Omit<CreateReviewsPageUrlProps, 'query' | 'colorKey' | 'type'>
) => {
  return (
    'https://www.wearfigs.com' +
    createReviewsPageUrl({
      ...props,
      type: 'read-review',
      colorKey: null,
    })
  )
}
